"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passwords = Passwords;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
function Passwords({ rules, intl }) {
    const { passwordRules, repeatPasswordRules } = rules;
    return ((0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, lg: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CandidateRegistrationFormField.password, rules: passwordRules, label: intl.formatMessage({
                        id: 'registration_student.registration_student_form.password',
                    }), validateFirst: true, children: (0, jsx_runtime_1.jsx)(elements_1.Input.Password, { autoComplete: "off" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, lg: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CandidateRegistrationFormField.password_repeat, rules: repeatPasswordRules, label: intl.formatMessage({
                        id: 'registration_student.registration_student_form.passwordRepeat',
                    }), validateFirst: true, children: (0, jsx_runtime_1.jsx)(elements_1.Input.Password, { autoComplete: "off" }) }) })] }));
}
